import React from 'react';
import {useOrganizationBranding} from '../Home/MinhaOrganizadora/hooks';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';
import { FaTachometerAlt, FaUsers, FaBuilding, FaGem, FaList, FaStar, FaBook, FaGithub, FaRegLaughWink, FaHeart, FaWineBottle, FaUserAlt, FaVideo, FaTruckMoving, FaBriefcase, FaFolderPlus, FaCog, FaChartLine, FaUser, FaQuestion } from 'react-icons/fa';
import { GiRead } from "react-icons/gi";
import Logo from '../assets/images/logo-ontest-branco.png';
// import LogoIbest from '../assets/images/logo_ibest.jpg';

import { Link, NavLink } from 'react-router-dom';
import { MdCopyright,MdOutlineQuestionAnswer,MdApartment, MdQuestionAnswer, MdComputer,MdClass, MdOutlineContentPaste, MdPrint } from 'react-icons/md';
import { useSelector } from 'react-redux';
import moment from 'moment';
import './sidebar.css';
import { can, canManageMembers, unrestricted } from '../permissions';

const Aside = ({ image, collapsed, toggled, handleToggleSidebar }) => {
  const branding=useOrganizationBranding();
  // #084808
  const user_role = useSelector(store => store.AppReducer.user.role);
  const user = useSelector(store => store.AppReducer.user);

  return (
    <ProSidebar
      image={false}
      collapsed={collapsed}
      toggled={toggled}
      className="hidethis modern-sidebar"
      breakPoint="md"
      style={{ position: 'fixed' }}
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader className="sidebar-header">
        <div className="logo-wrapper">
          <img src={branding.data?.logo_url||Logo} alt={branding.data?.name||"OnTest"} onError={event=>{event.currentTarget.onerror=null;event.currentTarget.src=Logo;}} />
        </div>
      </SidebarHeader>

      {(user_role == 'viwer'
      ) && <SidebarContent>
        <Menu iconShape="circle">
          <MenuItem
            icon={<MdPrint />}
          >

            <NavLink exact to="/" activeClassName="menu-active">{'Diamagrações' }</NavLink>
          </MenuItem>
          </Menu>
      </SidebarContent>}

      {(user_role == 'region_admin' || user_role=='faculdade') && <SidebarContent>
        <Menu iconShape="circle">
          {can(user, 'processo_seletivo') && <MenuItem
            icon={<MdApartment />}
          >

            <NavLink exact to="/" activeClassName="menu-active">{(user.empresa == null || user.empresa.change_text == false) ? 'Instituições' : ("Processos Seletivos")}</NavLink>
          </MenuItem>}

          {unrestricted(user) && user?.empresa?.plan?.training && <SubMenu title="Gestão de treinamentos" icon={<MdClass />}>
            <MenuItem icon={<MdOutlineContentPaste />}>
              <NavLink to="/conteudos" activeClassName="menu-active">Conteúdos</NavLink>
            </MenuItem>
            <MenuItem icon={<FaList />}>
              <NavLink to="/modulos" activeClassName="menu-active">Módulos</NavLink>
            </MenuItem>

            <MenuItem icon={<FaList />}>
              <NavLink to="/treinamentos" activeClassName="menu-active">Treinamentos</NavLink>
            </MenuItem>
          </SubMenu>}

          {can(user, 'disciplinas_questoes') && <MenuItem
            icon={<MdOutlineQuestionAnswer />}
          >

            <NavLink exact to="/disciplinas" activeClassName="menu-active">{("Disciplinas")}</NavLink>
          </MenuItem>}

          {can(user, 'disciplinas_questoes') && <MenuItem
          icon={<FaBook />} // Replace MdOutlineQuestionAnswer with FaQuestion
        >
          <NavLink exact to="/banca-questoes" activeClassName="menu-active">{("Questões Públicas")}</NavLink>
        </MenuItem>}

          {can(user, 'questionarios') && (user.role == 'region_admin' || (user.empresa == null || user.empresa.hide_questionario == false)) && <MenuItem
            icon={<FaQuestion />}
          >

            <NavLink exact to="/questionarios" activeClassName="menu-active">{("Questionários")}</NavLink>
          </MenuItem>}





          {can(user, 'banca_questoes') && <SubMenu title="Banca de Questões" icon={<MdQuestionAnswer />}>
            <MenuItem icon={<FaUser />}>
              <NavLink to="/elaboradores" activeClassName="menu-active">Elaboradores</NavLink>
            </MenuItem>
            <MenuItem icon={<FaList />}>
              <NavLink to="/demandas" activeClassName="menu-active">Demandas</NavLink>
            </MenuItem>

            <MenuItem icon={<FaList />}>
              <NavLink to="/recursos" activeClassName="menu-active">Recursos de Questão</NavLink>
            </MenuItem>

            <MenuItem icon={<FaStar />}>
              <NavLink to="/avaliar-questoes" activeClassName="menu-active">Avaliar questões</NavLink>
            </MenuItem>
          </SubMenu>}

          {user_role == 'region_admin' && <MenuItem
            icon={<FaBuilding />}
          >

            <NavLink exact to="/organizadoras" activeClassName="menu-active">{("Organizadoras")}</NavLink>
          </MenuItem>}
          {user.role == 'region_admin' && <MenuItem icon={<MdOutlineContentPaste />}>
            <NavLink exact to="/logs-integracao" activeClassName="menu-active">Logs de integração</NavLink>
          </MenuItem>}


          {canManageMembers(user) && <MenuItem
            icon={<FaUsers />}
          >

            <NavLink exact to="/membros" activeClassName="menu-active">{("Membros da equipe")}</NavLink>
          </MenuItem>}

          {can(user,'portal_configuracoes')&&<MenuItem icon={<FaBuilding/>}><NavLink to="/minha-organizadora" activeClassName="menu-active">Minha organizadora</NavLink></MenuItem>}
          {branding.data?.portal_enabled&&can(user,'portal_inscricoes')&&<MenuItem icon={<FaUsers/>}><NavLink to={`/instituicao/portal/${branding.data.id}/inscricoes`} activeClassName="menu-active">Inscrições</NavLink></MenuItem>}
          {unrestricted(user) && <MenuItem
            icon={<MdComputer />}
          >

            <NavLink exact to="/system" activeClassName="menu-active">{("Módulos do sistema")}</NavLink>
          </MenuItem>}



        </Menu>
      </SidebarContent>}

      <SidebarFooter className="sidebar-footer">
        <a href="https://www.ontest.com.br" target="_blank" rel="noopener noreferrer"
          className="copyright-link" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MdCopyright style={{ marginRight: 2 }} />
          <div>OnTest {moment().format('YYYY')}</div>
        </a>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Aside;
